import { IconHasTooltipStyled } from '@/pages/Settings/Components/EstimateRules/components/IconHasTooltip/styled';
import { Icon, IconSource, Tooltip } from '@shopify/polaris';
import { ReactNode } from 'react';

interface IProps {
  onClick?: () => void;
  icon?: IconSource;
  iconElement?: ReactNode;
  tooltipContent: string;
}

export default function IconHasTooltip({ icon, onClick, tooltipContent, iconElement }: IProps) {
  return (
    <IconHasTooltipStyled onClick={onClick} className={onClick ? 'cursor-pointer' : ''}>
      <Tooltip content={tooltipContent}>
        <>
          {icon ? <Icon tone="subdued" source={icon} /> : null}
          {iconElement ? <div className="wrap-icon">{iconElement}</div> : null}
        </>
      </Tooltip>
    </IconHasTooltipStyled>
  );
}
